// @ts-nocheck
export function addVizurySmartTagScript() {
	try {
		const viz = document.createElement("script");
		viz.type = "text/javascript";
		viz.async = true;
		viz.src = ("https:" == document.location.protocol ? "https://tags.vizury.com" : "http://tags.vizury.com") + "/analyze/pixel.php?account_id=VIZVRM5039";
		const s = document.getElementsByTagName("script")[0];
		s.parentNode.insertBefore(viz, s);
		viz.onload = function() {
			try {
				pixel.parse();
			} catch (i) {
			}
		};
		viz.onreadystatechange = function() {
			if (viz.readyState == "complete" || viz.readyState == "loaded") {
				try {
					pixel.parse();
				} catch (i) {
				}
			}
		};
	} catch (i) {
	}
};
